/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {useStaticQuery, graphql} from 'gatsby';

const DEFAULT_BREADCRUMBS = JSON.stringify(
    {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [{'@type': 'ListItem', 'position': 1, 'name': 'Miuros', 'item': 'https://miuros.com/'}]
    }
);

const SEO = ({description, lang, meta, title, breadCrumbJson}) => {
  const {site} = useStaticQuery(
      graphql`
          query {
              site {
                  siteMetadata {
                      title
                      description
                  }
              }
          }
      `
  );

  const metaDescription = description || site.siteMetadata.description;

  return (
      <Helmet
          htmlAttributes={{
            lang
          }}
          title={title}
          titleTemplate={`%s | ${site.siteMetadata.title}`}
          meta={[
            {
              name: `description`,
              content: metaDescription
            },
            {
              property: `og:title`,
              content: title
            },
            {
              property: `og:description`,
              content: metaDescription
            },
            {
              property: `og:type`,
              content: `website`
            }
          ].concat(meta)}
      >
        <script type="application/ld+json">{breadCrumbJson || DEFAULT_BREADCRUMBS}</script>
      </Helmet>
  );
};

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
};

const makeBreadCrumbJson = (breadcrumbStructure) => {
  const listElements = makeBreadcrumbs(breadcrumbStructure);

  const obj = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': listElements
  };

  return JSON.stringify(obj);
};

const makeBreadcrumbs = (breadCrumbList) => {
  return breadCrumbList.map((b, idx) => {
    if ((breadCrumbList.length - 1) !== idx) {
      return {
        '@type': 'ListItem',
        'position': idx + 1,
        ...b
      };
    } else {
      return {
        '@type': 'ListItem',
        'position': idx + 1,
        'name': b['name']
      };
    }

  });
};

export {SEO, makeBreadCrumbJson};
